import { Resource } from "../types/Resource";

export const resourceGroups: Resource[] = [
  {
    groupName: "Wellness Services",
    resources: [
      { name: "HealthFirst Wellness Center", phone: "(555) 555-0101" },
      { name: "MindBody Balance Clinic", phone: "(555) 555-0101" },
      { name: "VitalityWell Solutions", phone: "(555) 555-0101" },
    ],
  },
  {
    groupName: "Malpractice Insurance Carriers",
    resources: [
      { name: "SecureGuard Insurance Co.", phone: "(555) 555-0101" },
      { name: "MedDefend Assurance Services", phone: "(555) 555-0101" },
      { name: "LiabilityShield Providers", phone: "(555) 555-0101" },
    ],
  },
  {
    groupName: "Corporate Attorneys",
    resources: [
      { name: "EliteLegal Solutions", phone: "(555) 555-0101" },
      { name: "CorporateAdvise Law Firm", phone: "(555) 555-0101" },
      { name: "StrategicLegal Partners", phone: "(555) 555-0101" },
    ],
  },
  {
    groupName: "Accountants and Tax Specialists",
    resources: [
      { name: "Precision Tax Services", phone: "(555) 555-0101" },
      { name: "Elite Financial Advisors", phone: "(555) 555-0101" },
      { name: "TaxMaster Consultants", phone: "(555) 555-0101" },
    ],
  },
  {
    groupName: "Financial Planners",
    resources: [
      { name: "WealthPlan Advisors", phone: "(555) 555-0101" },
      { name: "StrategicInvest Partners", phone: "(555) 555-0101" },
      { name: "CapitalGrowth Consultants", phone: "(555) 555-0101" },
    ],
  },
];
